export default function EnforceTrailingSlash() {
    var pathname = window.location.pathname;
    if (pathname.substr(pathname.length - 1, 1) !== "/") {
        window.history.replaceState({}, "", "".concat(pathname, "/").concat(window.location.search).concat(window.location.hash));
    }
}
